"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerErrors = void 0;
var DealerErrors;
(function (DealerErrors) {
    DealerErrors["DEALER_CONNECTION_ERROR"] = "DEALER_CONNECTION_ERROR";
    DealerErrors["DEALER_AUTHENTICATION_FAILED"] = "DEALER_AUTHENTICATION_FAILED";
    DealerErrors["DEALER_ERROR"] = "DEALER_ERROR";
    DealerErrors["ENDPOINT_NOT_DEFINED"] = "ENDPOINT_NOT_DEFINED";
    DealerErrors["INVALID_ENDPOINT"] = "INVALID_ENDPOINT";
})(DealerErrors = exports.DealerErrors || (exports.DealerErrors = {}));
//# sourceMappingURL=typedefs.js.map